export enum InterestServices {
  REVIEW_MANAGER = 'REVIEW_MANAGER',
  REVIEW_BOOST = 'REVIEW_BOOST',
  MEDICONTENTS = 'MEDICONTENTS',
  AI_ENGINE_OPTIMIZER = 'AI_ENGINE_OPTIMIZER'
}

export interface PostConsultationRequest {
  applicantName: string;
  hospitalName: string;
  region: string;
  contactNumber: string;
  email: string;
  interestServices: InterestServices[];
  description: string;
  agreedToTerms: boolean;
}
